import { message as Message, notification as Notification } from 'antd'
import React from 'react'

//Todo: CMS-2089

type TriggerMessageParams = {
  message?: string
  description?: React.ReactNode
  duration?: number
  type?: 'success' | 'error' | 'info' | 'warning' | 'loading'
  displayType?: 'notification' | 'message'
  onClick?: () => void
  messageConfig?: Record<string, any>
}

export const triggerMessage = ({
  message,
  description,
  duration,
  type,
  displayType,
  onClick = null,
  messageConfig = {},
}: TriggerMessageParams = {}) => {
  if (displayType === 'notification') {
    Notification[type]({
      message,
      // temp fix after antd update with notification description(check in new antd version if margin-bottom issue is fixed)
      description: !description ? (
        <div style={{ marginTop: -8 }} />
      ) : (
        description
      ),
      duration,
      ...(onClick ? { onClick } : {}),
    })
  } else if (displayType === 'message') {
    if (Object.keys(messageConfig).length > 0) {
      Message[type](messageConfig as any)
    } else {
      Message[type](message, duration)
    }
  }
}

export const triggerErrorMessage = ({
  message = 'Something went wrong!',
  description = '',
  duration = 3,
  displayType = 'notification',
}: TriggerMessageParams = {}) => {
  return triggerMessage({
    message,
    // temp fix after antd update with notification description(check in new antd version if margin-bottom issue is fixed)
    description: !description ? <div style={{ marginTop: -8 }} /> : description,
    duration,
    displayType,
    type: 'error',
  })
}

export const destroyMessage = key => {
  Message.destroy(key)
}

export const useErrorMessage = (error, config = {}) => {
  return () => {
    if (!error) return triggerErrorMessage()
    if (typeof error === 'string') error = { message: error }
    return triggerErrorMessage(Object.assign(error, config))
  }
}

export const triggerSuccessMessage = ({
  message = 'Something went wrong!',
  description = '',
  duration = 4,
  displayType = 'notification',
}: TriggerMessageParams = {}) => {
  return triggerMessage({
    message,
    description,
    duration,
    displayType,
    type: 'success',
  })
}

export const useSuccessMessage = (error, config = {}) => {
  return () => {
    if (!error) return triggerSuccessMessage()
    if (typeof error === 'string') error = { message: error }
    return triggerSuccessMessage(Object.assign(error, config))
  }
}
